if (window.Promise) {
    delete window.Promise
}


// WEBPACK FOOTER //
// ./src/disableNativePromises.js